import { Modal } from "@mui/material";
import { ReactComponent as CloseIcon } from "../../../../assets/close.svg";
import style from "./style.module.scss";

const ZoomModal = ({ open, handleClose, img }) => (
  <Modal className={style.modal} open={open} onClose={handleClose}>
    <div className={style.content}>
      <div className={style.closeIcon} onClick={handleClose}>
        <CloseIcon />
      </div>

      {img?.url && (
        <img
          className={style.image}
          src={img.url}
          alt={img.alt ?? img.title ?? undefined}
          loading="lazy"
        />
      )}
    </div>
  </Modal>
);

export default ZoomModal;
